import { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { PageLoader } from "src/components";
import { DataProviderContext } from "src/core/provider/dataProvider";
import { ConfigD } from "src/utils/api/configD";
import { getFabricRoute } from "src/utils/routesUtils";

import { PreviewChangesDrawer } from "./previewChangesDrawer";

interface FabricPreviewChangesDrawerProps {
  readonly onClose: () => void;
}

export const FabricPreviewChangesDrawer = ({
  onClose
}: FabricPreviewChangesDrawerProps) => {
  const { fabric } = useContext(DataProviderContext);

  const fabricId = fabric?.id || "";
  const redirect = useNavigate();

  const fetchCandidates = useCallback(() => {
    return ConfigD.getFabricTransactions(fabricId);
  }, [fabricId]);

  const handleReviewClick = useCallback(() => {
    redirect(getFabricRoute(fabricId, "candidate"));
  }, [redirect, fabricId]);

  if (!fabricId) {
    return <PageLoader text="Loading preview changes" />;
  }

  return (
    <PreviewChangesDrawer
      onClose={onClose}
      fetchCandidates={fetchCandidates}
      onReviewClick={handleReviewClick}
      contextId={fabricId}
    />
  );
};
